import "./platform.js";

SEOSnippetPreview.FacebookPlatform = class extends SEOSnippetPreview.Platform {
  constructor(options) {
    super(
      {
        id: "facebook",
        title: "Facebook",
        isSocialNetwork: true,
        urlType: "base",
        targets: {
          title: 30,
          description: 70,
        },
      },
      options,
    );

    if (options.showSocialActions) {
      this.getShareLink();
    }
  }

  render(title, description, url) {
    this.el.html(`
      <div class="fb-container">
        <div class="fb-header">
          <div class="fb-header-meta">
            <div class="fb-meta-user">
              <img src="http://graph.facebook.com/${Sparkle.Config.social.facebook.id}/picture"/>
            </div>
            <div class="fb-meta-details">
              <h3 class="details-username">${Sparkle.Config.social.facebook.name}</h3>
              <div class="details-info">
                <div class="info-item info-time">Just Now</div>
                <span class="info-item"> · </span>
                <div class="info-item info-place">${Sparkle.Config.social.facebook.location}</div>
                <div class="info-item info-privacy"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="fb-post">

        </div>
        <div class="fb-img preview-image" data-behaviour="${this.options.editable ? "edit-snippet-thumbnail" : ""}"></div>
        <div class="fb-footer" data-behaviour="${this.options.editable ? "edit-snippet" : ""}">
          <div class="fb-footer-site preview-meta-url">${url}</div>
          <div class="fb-footer-title preview-meta-title">${title}</div>
          <div class="fb-footer-text preview-meta-text">${description}</div>
        </div>
      </div>
    `);

    return this;
  }
};
